module.exports = __webpack_public_path__ + "img/logo.cc4cb183.png";